package at.apa.statistictracker.db

import com.squareup.sqldelight.ColumnAdapter
import kotlin.Long
import kotlin.String
import kotlinx.serialization.json.JsonElement

public data class StatisticPayloadTable(
  public val id: Long,
  public val payload: JsonElement,
  public val timestampUnixMillis: Long
) {
  public override fun toString(): String = """
  |StatisticPayloadTable [
  |  id: $id
  |  payload: $payload
  |  timestampUnixMillis: $timestampUnixMillis
  |]
  """.trimMargin()

  public class Adapter(
    public val payloadAdapter: ColumnAdapter<JsonElement, String>
  )
}
